import { Translation } from '../types';

export const pl: Translation = {
  common: {
    loading: 'Ładowanie...',
    error: 'Błąd',
    cancel: 'Anuluj',
    save: 'Zapisz',
    close: 'Zamknij',
    search: 'Szukaj',
    reload: 'Odśwież',
    logout: 'Wyloguj',
    dashboard: 'Panel główny',
    products: 'Produkty',
    settings: 'Ustawienia',
    language: 'Język',
    businessHours: 'Godziny pracy',
    back: 'Wstecz',
    selectAll: 'Zaznacz wszystko',
    deselectAll: 'Odznacz wszystko',
    success: 'Sukces',
    selected: 'Wybrane',
    confirm: 'Potwierdź',
    required: 'Wymagane',
    requiredMarker: '*',
    previous: 'Poprzedni',
    next: 'Następny',
    allRightsReserved: 'Wszystkie prawa zastrzeżone.',
  },
  auth: {
    login: 'Logowanie',
    email: 'Adres e-mail',
    password: 'Hasło',
    loginButton: 'Zaloguj się',
    loggingIn: 'Logowanie...',
    loginSuccess: 'Pomyślnie zalogowano',
    loginError: 'E-mail lub hasło jest nieprawidłowe',
    invalidEmail: 'Proszę podać prawidłowy adres e-mail',
    requiredFields: 'Proszę podać e-mail i hasło',
    demoAccount: 'Konto demo:',
    loginDescription: 'Zaloguj się na swoje konto',
    welcomeMessage: 'Witamy w Twojej przestrzeni biznesowej',
    // Registration
    register: 'Rejestracja',
    createAccount: 'Utwórz konto',
    confirmPassword: 'Potwierdź hasło',
    passwordRequirements: 'Min. 8 znaków: wielka litera, mała litera, cyfra i symbol',
    passwordsDoNotMatch: 'Hasła nie są zgodne',
    registrationSuccess: 'Rejestracja zakończona pomyślnie',
    registrationDescription: 'Utwórz swoje konto biznesowe',
    alreadyHaveAccount: 'Masz już konto?',
    signIn: 'Zaloguj się',
    dontHaveAccount: 'Nie masz konta?',
    creatingAccount: 'Tworzenie konta...',
    registrationNote: 'Uwaga:',
    registrationNotePoints: {
      erpLinking: 'Jeśli masz istniejące konto biznesowe, Twój adres e-mail zostanie automatycznie połączony',
      companyEmail: 'Proszę użyć firmowego adresu e-mail do rejestracji',
      contactSupport: 'Skontaktuj się z pomocą przy rejestracji'
    },
    b2bUsers: 'Klienci biznesowi:',
    registeredEmail: 'Zarejestrowany adres e-mail',
    registeredPassword: 'Hasło ustawione podczas rejestracji',
    b2bCustomerRequired: 'E-mail nie rozpoznany. Skontaktuj się ze sprzedażą w sprawie konta biznesowego.',
    b2bVerificationError: 'Błąd weryfikacji. Skontaktuj się z pomocą.',
    // Password Reset
    passwordReset: 'Reset hasła',
    passwordResetDescription: 'Otrzymaj tymczasowe hasło przez e-mail',
    getTemporaryPassword: 'Pobierz tymczasowe hasło',
    processing: 'Przetwarzanie...',
    passwordResetComplete: 'Reset hasła ukończony',
    temporaryPasswordGenerated: 'Wygenerowano tymczasowe hasło',
    temporaryPassword: 'Tymczasowe hasło',
    backToLogin: 'Powrót',
    securityNotice: 'Informacja o bezpieczeństwie:',
    securityNotePoints: {
      keepSecret: 'Zachowaj hasło w tajemnicy',
      changeAfterLogin: 'Zmień po zalogowaniu',
      expires24Hours: 'Ważne przez 24h'
    },
    resetNote: 'Uwaga:',
    resetNotePoints: {
      registeredEmail: 'Wprowadź swój zarejestrowany adres e-mail',
      passwordDisplayed: 'Tymczasowe hasło zostanie wyświetlone na ekranie',
      changeRequired: 'Wymagana jest zmiana hasła po zalogowaniu'
    },
    copied: 'Skopiowano',
    copySuccessMessage: 'Tymczasowe hasło zostało skopiowane do schowka.',
    forgotPassword: 'Zapomniałeś hasła?',
    // Password Reset Email Request
    sendResetLink: 'Wyślij link resetujący',
    sendingEmail: 'Wysyłanie e-maila...',
    emailSent: 'E-mail wysłany',
    emailSentMessage: 'Jeśli ten adres e-mail istnieje w naszym systemie, otrzymasz wkrótce link do resetowania hasła.',
    emailNotSent: 'E-mail nie został wysłany',
    emailSentInfo: 'Sprawdź swoją skrzynkę odbiorczą i folder spam',
    checkEmail: 'Sprawdź e-mail',
    emailInstructions: 'Instrukcje resetowania hasła zostały wysłane',
    nextSteps: 'Następne kroki:',
    nextStepsList: {
      checkInbox: 'Sprawdź swoją skrzynkę odbiorczą i folder spam',
      clickLink: 'Kliknij link resetujący w e-mailu',
      linkExpires: 'Link wygasa po 24 godzinach',
      contactSupport: 'Skontaktuj się z pomocą techniczną, jeśli nie otrzymasz e-maila',
      rateLimitInfo: 'Ograniczenie do 3 próśb na godzinę'
    },
    // Password Reset Completion
    resetLinkSent: 'Link resetujący wysłany',
    resetSuccess: 'Hasło zostało pomyślnie zresetowane',
    passwordUpdated: 'Hasło zaktualizowane',
    passwordUpdateMessage: 'Twoje hasło zostało pomyślnie zaktualizowane. Możesz teraz zalogować się za pomocą nowego hasła.',
    loginWithNewPassword: 'Zaloguj się za pomocą nowego hasła',
    // Reset Token Page
    resetToken: 'Resetuj hasło',
    invalidToken: 'Nieprawidłowy token resetowania',
    expiredToken: 'Token resetowania wygasł',
    tokenValid: 'Token resetowania jest prawidłowy',
    newPassword: 'Nowe hasło',
    confirmNewPassword: 'Potwierdź nowe hasło',
    updatePassword: 'Zaktualizuj hasło',
    updatingPassword: 'Aktualizowanie hasła...',
    passwordMismatch: 'Hasła nie są zgodne',
    resetInstructions: 'Wprowadź nowe hasło, aby zakończyć reset',
  },
  accountInfo: {
    title: 'Informacje o koncie',
    loading: 'Ładowanie informacji o koncie...',
    error: 'Błąd',
    errorMessage: 'Nie udało się pobrać informacji o koncie',
    back: 'Wstecz',
    basicInfo: 'Podstawowe informacje',
    name: 'Nazwa',
    email: 'Adres e-mail',
    contactId: 'ID Klienta Knitido',
    contactNumber: 'Numer kontaktu',
    noInfo: 'Brak informacji',
    companyInfo: 'Informacje o firmie',
    company: 'Nazwa firmy',
    position: 'Stanowisko',
    vatId: 'NIP',
    billingAddress: 'Adres rozliczeniowy',
    deliveryAddress: 'Adres dostawy',
    addressInfo: 'Informacje adresowe',
    billingDescription: 'Adres do wysyłania faktur i dokumentów kontraktowych',
    deliveryDescription: 'Standardowy adres dostawy produktów',
    sameAsBilling: '※ Taki sam jak adres rozliczeniowy',
    sameAsDelivery: '※ Taki sam jak adres dostawy',
    companyName: 'Nazwa firmy',
    contactPerson: 'Osoba kontaktowa',
    address: 'Adres',
    phoneNumber: 'Numer telefonu',
    billingUsage: 'Używany jako miejsce dostarczania faktur, umów i innych ważnych dokumentów',
    deliveryUsage: 'Używany jako standardowy adres dostawy zamówionych produktów',
    alsoUsedForDelivery: 'Używany również jako miejsce dostarczania',
    accountType: 'Typ konta',
    addressId: 'ID adresu',
    // Address editing functionality
    edit: 'Edytuj',
    editDeliveryAddress: 'Edytuj adres dostawy',
    editDeliveryDescription: 'Zaktualizuj informacje o adresie dostawy',
    newDeliveryAddress: 'Dodaj nowy adres dostawy',
    newDeliveryDescription: 'Wprowadź szczegóły nowego adresu dostawy',
    noDeliveryAddress: 'Nie skonfigurowano adresu dostawy',
    success: 'Sukces',
    addressUpdated: 'Adres dostawy został pomyślnie zaktualizowany',
    updateError: 'Nie udało się zaktualizować adresu dostawy',
    requiredFields: 'Proszę wypełnić wszystkie wymagane pola',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    streetAddress: 'Ulica i numer',
    streetAddress2: 'Ulica i numer 2',
    city: 'Miasto',
    country: 'Kraj',
    selectCountry: 'Wybierz kraj...',
    searchCountry: 'Szukaj kraju...',
    noCountryFound: 'Nie znaleziono kraju.',
    postalCode: 'Kod pocztowy',
    companyNamePlaceholder: 'Wprowadź nazwę firmy',
    firstNamePlaceholder: 'Imię',
    lastNamePlaceholder: 'Nazwisko',
    streetAddressPlaceholder: 'Wprowadź adres ulicy',
    streetAddress2Placeholder: 'Mieszkanie, lokal, itp.',
    cityPlaceholder: 'Wprowadź miasto',
    postalCodePlaceholder: 'Wprowadź kod pocztowy',
    billingNotEditable: 'Adresu rozliczeniowego nie można edytować.',
    billingContactSupport: 'Skontaktuj się z pomocą techniczną w sprawie zmian.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} adresów dostawy',
    noDeliveryAddresses: 'Brak zarejestrowanych adresów dostawy',
    defaultAddress: 'Domyślny',
    selectDeliveryAddress: 'Wybierz adres dostawy',
    addNewAddress: 'Dodaj nowy adres',
    editAddress: 'Edytuj adres',
    deleteAddress: 'Usuń adres',
    confirmDelete: 'Potwierdź usunięcie',
    confirmDeleteMessage: 'Czy na pewno chcesz usunąć ten adres? Tej czynności nie można cofnąć.',
    addressAddedSuccess: 'Dodano adres dostawy',
    addressDeletedSuccess: 'Usunięto adres dostawy',
    deleteError: 'Nie udało się usunąć adresu dostawy',
    saving: 'Zapisywanie...',
    cancel: 'Anuluj',
    saveChanges: 'Zapisz zmiany',
    selectedDeliveryAddress: 'Wybrany adres dostawy',
  },
  dashboard: {
    title: 'Partner biznesowy',
    subtitle: 'System zamawiania produktów',
    welcome: 'Witamy,',
    welcomeMessage: 'Witamy w systemie zamawiania Partnera biznesowego. Tutaj możesz zamawiać produkty.',
    productCatalog: 'Katalog produktów',
    productCatalogDesc: 'Przeglądaj i zamawiaj dostępne produkty',
    viewProducts: 'Zobacz produkty',
    orderHistory: 'Historia zamówień',
    orderHistoryDesc: 'Zobacz poprzednie zamówienia (wkrótce)',
    accountSettings: 'Ustawienia konta',
    accountSettingsDesc: 'Zarządzaj informacjami o koncie (wkrótce)',
    comingSoon: 'Wkrótce',
    infoTitle: 'O użytkowaniu',
    orderingInfo: 'Zamawianie produktów',
    orderingDesc: 'Wybierz produkty z katalogu i określ rozmiar oraz kolor. Dostępne są informacje o stanie magazynowym w czasie rzeczywistym.',
    supportInfo: 'Wsparcie',
    supportDesc: 'Jeśli masz pytania, skontaktuj się z nami.',
    viewOrderHistory: 'Zobacz historię zamówień',
    viewOrders: 'Zobacz zamówienia',
    accountInfo: 'Informacje o koncie',
    accountInfoDesc: 'Zobacz szczegóły swojego konta',
    viewDetails: 'Zobacz szczegóły',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Poniedziałek-piątek 9:00 - 15:00 CET',
    bulkImportDesc: 'Importuj zamówienia z plików Excel/CSV',
    importOrders: 'Importuj zamówienia',
  },
  products: {
    title: 'Lista produktów',
    subtitle: 'Partner biznesowy',
    searchPlaceholder: 'Szukaj według nazwy produktu lub SKU...',
    productId: 'ID produktu',
    addToCart: 'Dodaj do koszyka',
    selectVariation: 'Wybierz wariant',
    price: 'Cena',
    priceNetNotice: 'Wszystkie ceny są cenami netto',
    stock: 'Stan magazynowy',
    color: 'Kolor',
    newProducts: 'Nowe Produkty',
    newProductBadge: 'NOWY',
    size: 'Rozmiar',
    quantity: 'Ilość',
    total: 'Suma',
    cart: 'Koszyk',
    checkout: 'Realizacja zamówienia',
    csvMode: 'Tryb szybki CSV',
    csvInfo: 'Dane produktów pobrane z danych CSV',
    csvUploadDate: 'Data przesłania CSV:',
    stockNote: '※ Informacje o stanie magazynowym są pobierane przy wyborze wariantów produktu',
    noProducts: 'Nie znaleziono produktów',
    noProductsDesc: 'Zmień kryteria wyszukiwania lub prześlij plik CSV dla szybszej wydajności.',
    retry: 'Spróbuj ponownie',
    pagination: 'elementy',
    variations: 'warianty',
    stockFetchError: 'Błąd pobierania stanu magazynowego',
    stockFetchFailed: 'Nie udało się pobrać stanu magazynowego',
    stockFetchFailedDesc: 'Nie można pobrać informacji o stanie magazynowym. Zostanie wyświetlony stan z CSV.',
    stockFetched: 'Pobrano informacje o stanie magazynowym',
    totalStock: 'Całkowity stan magazynowy',
    noStockAll: 'Wszystkie warianty mają zerowy stan magazynowy',
    noStockData: 'Nie zwrócono danych o stanie magazynowym',
    stockFetchErrorDesc: 'Wystąpił błąd podczas pobierania informacji o stanie magazynowym',
    selectionError: 'Błąd wyboru',
    enterQuantity: 'Proszę podać ilość',
    addedToCart: 'Dodano do koszyka',
    typesAdded: ' typów produktów dodanych',
    addToCartError: 'Błąd dodawania do koszyka',
    addToCartErrorDesc: 'Proszę spróbować ponownie',
    loadingStock: 'Ładowanie informacji o stanie magazynowym',
    csvDataInfo: 'Wyświetlanie informacji z danych CSV (nie rzeczywisty stan magazynowy)',
    filterByCategory: 'Filtruj według kategorii',
    allProducts: 'Wszystkie produkty',
    applyFilters: 'Zastosuj filtry',
    clearFilters: 'Wyczyść filtry',
    filters: 'Filtry',
    clearAll: 'Wyczyść wszystko',
    invalidDataFormat: 'Format danych produktu jest nieprawidłowy',
    loadFailed: 'Nie udało się załadować danych produktu',
    csvUploadComplete: 'Przesyłanie CSV zakończone',
    csvLoadedDesc: ' danych produktu załadowanych. Informacje o stanie magazynowym będą pobrane przy wyborze produktów.',
    searchTitle: 'Wyszukiwanie produktów',
    loadingProducts: 'Ładowanie danych produktów',
    noProductsCsv: 'Nie znaleziono produktów w danych CSV. Proszę zmienić kryteria wyszukiwania.',
    paginationDisplay: ' wyświetlone',
    previous: 'Poprzedni',
    next: 'Następny',
    selectionSummary: 'Podsumowanie wyboru',
    selectedQuantity: 'Wybrana ilość',
    items: ' elementy',
    viewDetails: 'Zobacz szczegóły',
    productImage: 'Zdjęcie produktu',
    correspondingVariations: 'Odpowiednie warianty',
    clickToEnlarge: 'Kliknij, aby powiększyć',
    productIdLabel: 'ID produktu',
    colorLabel: 'Kolor',
  },
  productDetail: {
    title: 'Szczegóły produktu',
    backToProducts: 'Powrót do produktów',
    productNotFound: 'Nie znaleziono produktu',
    productNotFoundDesc: 'Określony produkt nie istnieje lub został usunięty.',
    loading: 'Ładowanie produktu...',
    imageLoadError: 'Nie udało się załadować zdjęć',
    noImages: 'Brak dostępnych zdjęć',
    productDescription: 'Opis produktu',
    colors: 'Kolory',
    sizes: 'Rozmiary',
    colorCount: 'kolory',
    sizeCount: 'rozmiary',
    variationCount: 'warianty',
    selectVariation: 'Wybierz warianty',
    descriptionLanguageNote: '※ Opisy produktów są dostępne tylko w języku angielskim lub niemieckim',
  },
  colors: {
    schwarz: 'Czarny',
    weiß: 'Biały',
    grau: 'Szary',
    rot: 'Czerwony',
    blau: 'Niebieski',
    grün: 'Zielony',
    gelb: 'Żółty',
    rosa: 'Różowy',
    lila: 'Fioletowy',
    braun: 'Brązowy',
    orange: 'Pomarańczowy',
    beige: 'Beżowy',
    navy: 'Granatowy',
    dunkelblau: 'Ciemnoniebieski',
    hellblau: 'Jasnoniebieski',
    dunkelgrau: 'Ciemnoszary',
    hellgrau: 'Jasnoszary',
    bordeaux: 'Bordowy',
    türkis: 'Turkusowy',
    khaki: 'Khaki',
    mint: 'Miętowy',
    violett: 'Fioletowy',
    anthrazit: 'Antracytowy',
    blaugrau: 'Niebieskawo-szary',
    burgunderrot: 'Burgundowy',
    elfenbein: 'Kość słoniowa',
    karminrot: 'Karminowy',
    neongrün: 'Neonowy zielony',
    gelbgrün: 'Żółtozielony',
    pistazie: 'Pistacjowy',
    // Angielskie nazwy kolorów (używane w Product ID 237, itp.)
    blue: 'Niebieski',
    ivory: 'Kość słoniowa',
    green: 'Zielony',
    gold: 'Złoty',
    red: 'Czerwony',
  },
  categories: {
    category_21: 'Akcesoria',
    category_23: 'Skarpetki podstawowe',
    category_24: 'Oferty',
    category_29: 'B2B'
  },
  checkout: {
    title: 'Realizacja zamówienia',
    cartReview: 'Przegląd zamówienia',
    orderSummary: 'Podsumowanie zamówienia',
    shippingInfo: 'Informacje o wysyłce',
    billingInfo: 'Informacje rozliczeniowe',
    orderNotes: 'Uwagi do zamówienia',
    orderNotesPlaceholder: 'Specjalne żądania lub uwagi...',
    contactPerson: 'Osoba kontaktowa',
    phoneNumber: 'Numer telefonu',
    email: 'Adres e-mail',
    company: 'Firma',
    address: 'Adres',
    city: 'Miasto',
    postalCode: 'Kod pocztowy',
    country: 'Kraj',
    deliveryDate: 'Data dostawy',
    urgentDelivery: 'Dostawa ekspresowa (3-5 dni roboczych)',
    standardDelivery: 'Dostawa standardowa (7-10 dni roboczych)',
    placeOrder: 'Złóż zamówienie',
    backToCart: 'Powrót do wyboru produktów',
    requiredField: 'Pole wymagane',
    orderTotal: 'Suma zamówienia',
    subtotal: 'Suma częściowa',
    priceNetNotice: 'Wszystkie ceny są cenami netto',
    stockReservationNotice: 'Rezerwacja magazynowa zostanie dokonana po potwierdzeniu zamówienia.',
    stockCheckError: 'Błąd sprawdzania stanu magazynowego',
    stockCheckErrorDesc: 'Wystąpił błąd podczas sprawdzania stanu magazynowego. Proszę spróbować ponownie.',
    shipping: 'Wysyłka',
    shippingCost: 'Koszt wysyłki',
    tax: 'Podatek',
    orderSuccess: 'Zamówienie zakończone pomyślnie',
    orderSuccessMessage: 'Twoje zamówienie zostało pomyślnie złożone. Numer zamówienia: {orderNumber}',
    orderNumber: 'Numer zamówienia',
    thankYou: 'Dziękujemy za złożenie zamówienia!',
    orderConfirmation: 'Twoje zamówienie zostało pomyślnie złożone.',
    orderProcessing: 'Po sprawdzeniu przez nasz zespół wyślemy Ci potwierdzenie zamówienia e-mailem.',
    orderProcessingMessage: 'Twoje zamówienie zostało pomyślnie złożone. Po sprawdzeniu przez nasz zespół wyślemy Ci potwierdzenie zamówienia e-mailem.',
    continueShopping: 'Kontynuuj zakupy',
    emptyCart: 'Twój koszyk jest pusty',
    emptyCartMessage: 'Dodaj produkty do koszyka, aby kontynuować',
    stockWarning: 'Ostrzeżenie o stanie magazynowym',
    stockWarningDesc: 'Niektóre produkty mają niewystarczający stan magazynowy. Proszę dostosować ilości.',
    stockError: 'Błąd stanu magazynowego',
    stockErrorDesc: 'Istnieją produkty z niewystarczającym stanem magazynowym. Proszę dostosować ilości.',
    refreshStock: 'Odśwież stan magazynowy',
    stockUpdated: 'Stan magazynowy zaktualizowany',
    stockUpdatedDesc: 'Stan magazynowy został zaktualizowany - zmieniono {changed} elementów',
    stockCheckDesc: 'Wyświetlone wyniki porównania z magazynem',
    stockOk: 'Stan magazynowy OK',
    stockShortage: 'Niedobór magazynowy',
    requestedQty: 'Żądana ilość',
    currentStock: 'Aktualny stan',
    stockShortageMsg: 'Niewystarczający stan magazynowy. Proszę dostosować ilość.',
    stockIssueWarning: 'Zamówienie nie może zostać potwierdzone z powodu problemów z magazynem.',
    stockDataMissing: 'Dane magazynowe są pobierane. Proszę chwilę poczekać.',
    outOfStock: 'Brak w magazynie.',
    maxAvailable: 'Maksimum',
    autoRestored: 'Koszyk przywrócony',
    autoRestoredDesc: 'Przedmioty z ostatniej sesji zostały przywrócone',
    maxQuantityReached: 'Osiągnięto maksymalną ilość magazynową.',
    // ERP Contact Search
    contactSearch: 'Wyszukiwanie kontaktu klienta',
    contactSearchDesc: 'Wprowadź adres e-mail zamawiającego, aby pobrać informacje kontaktowe',
    emailAddress: 'Adres e-mail',
    searchButton: 'Szukaj',
    searching: 'Wyszukiwanie',
    contactFound: 'Znaleziono kontakt',
    contactNotFound: 'Nie znaleziono kontaktu',
    contactId: 'ID Klienta Knitido',
    companyName: 'Firma',
    contactPersonLabel: 'Osoba kontaktowa',
    addressesFound: 'Znalezione adresy',
    addressType: 'Typ',
    addressBilling: 'Adres rozliczeniowy',
    addressDelivery: 'Adres dostawy',
    vatSourceCompany: 'Dane firmy',
    vatSourceBilling: 'Rozliczenie',
    vatSourceDelivery: 'Dostawa',
    addressOther: 'Inny',
    addressDetails: 'Adres',
    loadingAddresses: 'Ładowanie informacji adresowych...',
    addressRetrieved: 'Pobrano informacje adresowe',
    addressNotFound: 'Nie znaleziono informacji adresowych',
    addressNotFoundDesc: 'Brak zarejestrowanych informacji adresowych. Proszę wprowadzić ręcznie.',
    addressError: 'Błąd pobierania adresu',
    addressErrorDesc: 'Nie udało się pobrać informacji adresowych.',
    contactNotConfirmed: 'Kontakt klienta niepotwierdzony',
    contactNotConfirmedDesc: 'Proszę wprowadzić adres e-mail i wyszukać kontakt.',
    searchContact: 'Wyszukaj kontakt',
    inputError: 'Błąd danych wejściowych',
    inputErrorDesc: 'Informacje o wysyłce są niekompletne. Proszę sprawdzić.',
    processing: 'Przetwarzanie...',
    erpContactSearch: 'Wyszukiwanie kontaktu klienta',
    contactSearchError: 'Adres e-mail nie odpowiada żadnemu zarejestrowanemu kontaktowi.',
    // Product Images Toggle
    showProductImages: 'Pokaż zdjęcia produktów',
    showProductImagesDesc: 'Wyświetl zdjęcia produktów dla lepszego przeglądu (może zwiększyć czas ładowania)',
    // System Registration Info
    systemRegistrationInfo: 'Twoje informacje o kliencie',
    editShippingAddress: 'Edytuj adres dostawy',
    systemRegistrationInfoDesc: 'Twoje zarejestrowane informacje biznesowe. Proszę skontaktować się z reprezentantem, jeśli potrzebujesz zaktualizować szczegóły adresu rozliczeniowego.',
    // Order Summary
    regularPrice: 'Regularna cena hurtowa',
    offeredPrice: 'Cena oferowana',
    discount: 'Rabat',
    b2bCustomer: 'Klient B2B',
    pattern: 'Wzorzec',
    specialPriceApplied: 'Zastosowano cenę specjalną',
    customerClassification: 'Klasyfikacja klienta',
    paymentCondition: 'Warunki płatności',
    invoice: 'Faktura (NET 30)',
    prepayment: 'Przedpłata',
    paymentMethod: 'Metoda płatności',
    invoicePayment: 'Płatność fakturą',
    estimatedSubtotal: 'Szacowana suma częściowa',
    estimatedTotal: 'Szacowana suma całkowita',
    orderSummaryDisclaimer: 'Ceny pokazane tutaj są szacunkami. Po otrzymaniu Twojego zamówienia sprawdzimy je i wyślemy Ci wiążące potwierdzenie zamówienia z ostatecznymi cenami, kosztami wysyłki i podatkami e-mailem.',
    searchError: 'Błąd wyszukiwania',
    searchErrorDesc: 'Wystąpił błąd podczas wyszukiwania kontaktu.',
    confirmDeleteItem: 'Usuń element',
    itemDeleted: 'Element usunięty',
    confirmDeleteItemDesc: 'Czy na pewno chcesz usunąć następujący element z koszyka?',
    deleteConfirm: 'Usuń',
    contactNotes: 'Uwagi kontaktowe',
    contactNotesDesc: 'Masz pytania lub specjalne żądania? Proszę daj nam znać (opcjonalne)',
    contactNotesLabel: 'Wiadomość',
    contactNotesPlaceholder: 'np.: Pytania o produkt, specjalne wymagania, itp.',
    characters: 'znaków',
    contactIdLabel: 'ID Klienta Knitido',
    companyLabel: 'Firma',
    personLabel: 'Osoba kontaktowa',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Typ',
    destinationLabel: 'Miejsce przeznaczenia',
    // Shipping Form
    shippingTitle: 'Informacje o wysyłce',
    shippingDesc: 'Wprowadź adres dostawy produktów',
    companyRequired: 'Firma *',
    contactPersonRequired: 'Osoba kontaktowa *',
    emailRequired: 'Adres e-mail *',
    phoneRequired: 'Numer telefonu *',
    addressRequired: 'Adres 1 *',
    address2: 'Adres 2 (budynek/pokój)',
    postalCodeRequired: 'Kod pocztowy *',
    cityRequired: 'Miasto *',
    countryRequired: 'Kraj *',
    selectCountry: 'Wybierz kraj',
    shippingMethodRequired: 'Metoda wysyłki *',
    selectShippingMethod: 'Wybierz metodę wysyłki',
    urgentDeliveryOption: 'Dostawa ekspresowa (dodatkowe opłaty)',
    deliveryNotes: 'Uwagi do dostawy',
    deliveryNotesPlaceholder: 'Wprowadź preferencje czasowe dostawy lub inne żądania',
    standardShipping: 'Wysyłka standardowa (3-5 dni roboczych)',
    expressShipping: 'Wysyłka ekspresowa (1-2 dni robocze)',
    overnightShipping: 'Wysyłka nocna',
    germany: 'Niemcy',
    austria: 'Austria',
    switzerland: 'Szwajcaria',
    japan: 'Japonia',
    shippingAddressLabel: 'Adres dostawy',
    changeDeliveryAddress: 'Zmień adres dostawy',
    selectDeliveryAddress: 'Wybierz adres dostawy',
    // Shipping Cost Details
    freeShipping: 'Darmowa wysyłka',
    shippingError: 'Błąd',
    shippingZone: 'Strefa wysyłki',
    remainingForFreeShipping: '{amount} więcej do darmowej wysyłki',
    moreForFreeShipping: 'do darmowej wysyłki',
    freeShippingProgress: 'Darmowa wysyłka od',
    andAboveFreeShipping: 'i więcej dla darmowej wysyłki',
    freeShippingAchieved: 'Darmowa wysyłka zastosowana',
    threshold: 'i więcej',
    nextShippingTier: 'Następna zniżka na wysyłkę',
    moreForDiscount: 'więcej dla',
    shippingSavings: 'oszczędności na wysyłce',
    orderAmountThreshold: 'i więcej dla',
    specialRegionNotice: 'Zastosowano specjalną strefę wysyłki',
    defaultShippingApplied: 'Zastosowano standardowe stawki wysyłki',
    requestedQuantity: 'Żądana ilość',
    availableQuantity: 'Dostępna ilość',
    orderSubmitError: 'Błąd składania zamówienia',
    orderSubmitErrorDesc: 'Nie można złożyć zamówienia',
    upload: {
      title: 'Import zamówienia Excel/CSV',
      description: 'Prześlij plik Excel lub CSV z danymi zamówienia',
      dragDropOrClick: 'Przeciągnij i upuść plik tutaj lub kliknij, aby wybrać',
      dropHere: 'Upuść plik tutaj',
      supportedFormats: 'Obsługiwane formaty: Excel (.xlsx, .xls) i CSV (.csv)',
      maxSize: 'Maksymalny rozmiar pliku: {size} MB',
      processFile: 'Przetwórz plik',
      processing: 'Przetwarzanie pliku...',
      ready: 'Plik gotowy do podglądu',
      readyDescription: 'Twój plik został pomyślnie przetworzony i jest gotowy do przeglądu.',
      preview: 'Pokaż podgląd',
      errors: {
        fileTooLarge: 'Plik jest za duży. Maksymalny rozmiar: {size} MB',
        invalidFileType: 'Nieprawidłowy typ pliku. Prześlij plik Excel lub CSV',
        uploadFailed: 'Błąd przesyłania pliku',
      },
    },
    // Loading messages
    loadingPage: 'Ładowanie strony...',
    loadingStock: 'Sprawdzanie stanu magazynowego produktów...',
    loadingAccount: 'Ładowanie informacji o koncie...',
    loadingError: 'Wystąpił błąd...',
    loadingData: 'Ładowanie danych',
    // Toast messages
    addressRetrievedTitle: 'Pobrano informacje adresowe',
    addressSetAsDelivery: ' adres ustawiony jako miejsce dostawy.',
    contactFoundDesc: ' został rozpoznany.'
  },
  orderHistory: {
    title: 'Historia zamówień',
    searchPlaceholder: 'Szukaj według numeru zamówienia lub SKU...',
    noOrders: 'Nie znaleziono zamówień',
    noOrdersFound: 'Nie znaleziono pasujących zamówień',
    startShopping: 'Zobacz produkty',
    orderItems: 'Elementy zamówienia',
    viewDetails: 'Szczegóły',
    reorder: 'Zamów ponownie',
    orderDate: 'Data zamówienia',
    orderStatus: 'Status',
    orderTotal: 'Suma zamówienia',
    // Status translations
    statusPending: 'Oczekuje na płatność',
    statusProcessing: 'Przetwarzanie',
    statusConfirmed: 'Potwierdzone',
    statusShipped: 'Wysłane',
    statusDelivered: 'Dostarczone',
    statusCancelled: 'Anulowane',
    statusReturned: 'Zwrócone',
    statusRefunded: 'Zwrot środków',
    statusWarranty: 'Gwarancja',
    statusExchanged: 'Wymienione',
    statusRepair: 'Naprawa',
    statusUnknown: 'Nieznany',
    statusIncomplete: 'Niekompletne',
    statusWaitingPayment: 'Oczekuje na płatność',
    statusInPreparation: 'W przygotowaniu',
    statusClearedShipping: 'Odprawione do wysyłki',
    statusBeingShipped: 'W trakcie wysyłki',
    statusOutgoingBooked: 'Rezerwacja wychodząca',
    statusReturn: 'Zwrot',
    // Additional UI elements
    itemCount: 'elementy',
    itemCountSingular: 'element',
    refreshButton: 'Odśwież',
    errorFetchingOrders: 'Nie udało się pobrać historii zamówień',
    // Payment status features
    paymentStatus: 'Status płatności',
    markAsPaid: 'Oznacz jako opłacone',
    unmarkAsPaid: 'Usuń oznaczenie opłacone',
    paidOn: 'Opłacono',
    paymentMarked: 'Opłacone',
    notPaid: 'Nieopłacone',
    paymentMarkedSuccess: 'Oznaczono jako opłacone',
    paymentUnmarkedSuccess: 'Usunięto oznaczenie opłacone',
    paymentUpdateError: 'Błąd podczas aktualizacji statusu płatności',
    // Payment date dialog
    paymentDateTitle: 'Wprowadź informacje o płatności',
    paymentDateDescription: 'Wprowadź informacje o płatności dla zamówienia {orderNumber}',
    paymentDateLabel: 'Data płatności',
    selectDate: 'Wybierz datę',
    paymentDateHelp: 'Wybierz datę przelewu bankowego',
    paymentMethodLabel: 'Metoda płatności',
    bankTransfer: 'Przelew bankowy',
    invoice: 'Faktura',
    otherPayment: 'Inne',
    paymentReferenceLabel: 'Numer referencyjny',
    paymentReferencePlaceholder: 'np. Przelew z 01.01.2024',
    paymentReferenceHelp: 'Wprowadź informacje pomocne przy uzgodnieniu',
    notesLabel: 'Uwagi',
    notesPlaceholder: 'Dodatkowe informacje o płatności',
    // Filter options
    filterByPaymentStatus: 'Filtruj według statusu płatności',
    allOrders: 'Wszystkie zamówienia',
    paidOrders: 'Opłacone',
    unpaidOrders: 'Nieopłacone',
    // Sorting options
    sortBy: 'Sortuj według',
    sortByDate: 'Data zamówienia',
    sortByPaymentDate: 'Data płatności',
    sortByAmount: 'Kwota',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Szczegóły zamówienia',
    notFound: 'Nie znaleziono zamówienia',
    backToHistory: 'Powrót do historii zamówień',
    orderDate: 'Data zamówienia',
    orderItems: 'Elementy zamówienia',
    deliveryStatus: 'Status dostawy',
    estimatedDelivery: 'Szacowana dostawa',
    deliveredOn: 'Dostarczone dnia',
    downloadInvoice: 'Pobierz fakturę',
    statusDelivered: 'Dostarczone',
    statusShipped: 'Wysłane',
    statusConfirmed: 'Potwierdzone',
    statusCancelled: 'Anulowane',
    errorFetchingDetails: 'Nie udało się pobrać szczegółów zamówienia',
  },
  company: {
    name: 'Partner biznesowy',
    tagline: 'System Partnera biznesowego',
    copyright: '© 2025 System Partnera biznesowego. Wszystkie prawa zastrzeżone.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-mail',
    countries: {
      DE: 'Niemcy',
      AT: 'Austria',
      CH: 'Szwajcaria',
      FR: 'Francja',
      IT: 'Włochy',
      ES: 'Hiszpania',
      NL: 'Holandia',
      BE: 'Belgia',
      PL: 'Polska',
      SE: 'Szwecja',
      NO: 'Norwegia',
      FI: 'Finlandia',
      DK: 'Dania',
      LT: 'Litwa',
      LV: 'Łotwa',
      EE: 'Estonia',
    },
  },
  cart: {
    newCart: 'Nowy koszyk',
    currentCart: 'Aktualny koszyk',
    modified: 'zmodyfikowany',
    lastSaved: 'Ostatnio zapisane',
    unsavedChanges: 'niezapisane zmiany',
    saveCart: 'Zapisz koszyk',
    loadCart: 'Załaduj koszyk',
    deleteCart: 'Usuń koszyk',
    startNewCart: 'Rozpocznij nowy koszyk',
    savedCarts: 'Zapisane koszyki',
    cartSaved: 'Koszyk zapisany',
    cartDeleted: 'Koszyk usunięty',
    confirmDeleteCart: 'Usunąć koszyk?\n\nTej akcji nie można cofnąć.',
    confirmSwitchCart: 'Aktualny koszyk ma niezapisane zmiany.\n\nZaładowanie innego koszyka spowoduje utratę aktualnych zmian.\n\nKontynuować?',
    confirmSwitchCartTitle: 'Przełącz koszyk',
    confirmNewCart: 'Aktualny koszyk ma niezapisane zmiany.\n\nRozpoczęcie nowego koszyka spowoduje utratę aktualnych zmian.\n\nKontynuować?',
    confirmNewCartTitle: 'Rozpocznij nowy koszyk',
    confirmClearCart: 'Wyczyścić koszyk?\n\n{count} elementów zostanie usuniętych.\n\nTej akcji nie można cofnąć.',
    confirmClearCartTitle: 'Wyczyść koszyk',
    autoSaved: 'Automatycznie zapisane',
    itemsWillBeRemoved: 'elementy zostaną usunięte',
    changesWillBeLost: 'zmiany zostaną utracone',
    continueQuestion: 'Kontynuować?',
    cartStatus: 'Status koszyka',
    cartName: 'Nazwa koszyka',
    cartNamePlaceholder: 'np.: Zamówienie końca miesiąca',
    cartNameRequired: 'Proszę wprowadzić nazwę koszyka',
    saveCartDescription: 'Nadaj aktualnemu koszykowi nazwę i zapisz go. Możesz załadować go później.',
    cancelCart: 'Anuluj koszyk',
    proceedToCheckout: 'Przejdź do kasy',
    emptyCart: 'Koszyk jest pusty',
    erpDown: 'System zamówień jest niedostępny. Spróbuj ponownie później.',
    erpDegraded: 'System jest obecnie niestabilny. Zamówienia mogą się nie powieść.',
    erpDownSaveHint: 'Zapisz koszyk i złóż zamówienie po przywróceniu systemu.',
    erpSaveCart: 'Zapisz koszyk',
  },
  nav: {
    dashboard: 'Panel główny',
    products: 'Produkty',
    orderHistory: 'Historia zamówień',
    account: 'Informacje o koncie',
    bulkImport: 'Import masowy',
  },
  settings: {
    selectLanguage: 'Wybierz język',
    languagePreferenceSaved: 'Twoje preferencje zostaną zapisane na Twoim koncie na przyszłe wizyty.',
  },
  reorder: {
    allItemsAdded: '{count} produktów dodano do koszyka',
    partialSuccess: '{added} produktów dodano. {failed} produktów nie można dodać',
    allItemsFailed: 'Nie można dodać produktów do koszyka',
    error: 'Wystąpił błąd podczas ponownego zamawiania',
    itemDiscontinued: '{name} ({color}/{size}) został wycofany z oferty',
    itemOutOfStock: '{name} ({color}/{size}) jest niedostępny',
    partialStock: '{name} ({color}/{size}) tylko {available} dostępnych',
    confirmReorder: 'Potwierdź ponowne zamówienie',
    confirmReorderMessage: 'Dodać produkty z tego zamówienia do koszyka?',
    addingToCart: 'Dodawanie do koszyka...',
    checkingStock: 'Sprawdzanie dostępności...',
    checkoutTitle: 'Produkty dodane do koszyka',
    checkoutDescription: 'Dodano {count} produktów do koszyka. Czy chcesz przejść do kasy?',
  },
  bulkImport: {
    instructions: 'Jak importować zamówienia',
    step1: 'Pobierz plik szablonu zamówienia',
    step2: 'Wypełnij dane zamówienia z SKU i ilością',
    step3: 'Zapisz jako plik Excel (.xlsx) lub CSV',
    step4: 'Prześlij plik używając poniższego formularza',
    step5: 'Przejrzyj i potwierdź swoje zamówienie',
    downloadTemplate: 'Pobierz szablon',
    formatGuide: 'Przewodnik po formacie pliku',
    requiredColumns: 'Wymagane kolumny',
    skuDescription: 'Kod SKU produktu',
    quantityDescription: 'Ilość zamówienia (dodatnia liczba całkowita)',
    optionalColumns: 'Opcjonalne kolumny',
    notesDescription: 'Notatki wewnętrzne (np. numer PO, referencje) - tylko do własnej dokumentacji',
    formatNote: 'Pierwszy wiersz powinien zawierać nagłówki kolumn. Dane zaczynają się od drugiego wiersza.',
    parseSuccess: 'Pomyślnie przetworzono {count} pozycji z pliku',
    parseError: 'Błąd parsowania',
    validationError: 'Błędy walidacji',
    validationErrorGuidance: 'Kliknij przycisk „{showPreviewButton}”, aby przejrzeć szczegóły.',
    warnings: 'Ostrzeżenia',
    itemsParsed: 'Pomyślnie przetworzono {count} pozycji:',
    andMore: '...i {count} kolejnych pozycji',
    validationSummary: 'Podsumowanie walidacji',
    duplicateSKUs: 'Znaleziono duplikaty SKU',
    skuFormat: 'SKU może zawierać tylko litery, cyfry i myślniki',
    quantityRange: 'Ilość musi być między 1 a 9999',
    maxRows: 'Maksymalnie 1000 wierszy dozwolonych',
    rowsSkipped: '{count} wierszy zostało pominiętych z powodu błędów',
    previewTitle: 'Podgląd zamówienia',
    previewDescription: 'Przejrzyj i edytuj dane zamówienia przed kontynuowaniem',
    proceedToCart: 'Dodaj do koszyka',
    // File parsing messages
    fileEmpty: 'Plik jest pusty lub nie zawiera danych',
    fileTooManyRows: 'Plik zawiera za dużo wierszy ({current}). Maksymalnie dozwolone: {max}',
    invalidRowFormat: 'Nieprawidłowy format wiersza',
    missingColumns: 'Brakujące wymagane kolumny (SKU i Ilość)',
    missingSku: 'Brakujący SKU',
    invalidSkuFormat: 'Nieprawidłowy format SKU: "{sku}" (musi pasować do wzorca: {pattern})',
    skuTooLong: 'SKU za długi: "{sku}" (maksymalnie 50 znaków)',
    invalidQuantity: 'Nieprawidłowa ilość: "{quantity}" nie jest liczbą',
    quantityTooLow: 'Ilość za mała: {quantity} (minimum: {min})',
    quantityTooHigh: 'Ilość za duża: {quantity} (maksimum: {max})',
    notesRequired: 'Pole uwag jest wymagane',
    noValidData: 'Nie znaleziono prawidłowych danych. Sprawdź format pliku.',
    row: 'Wiersz {row}: {errors}',
    rowErrors: '...i {count} kolejnych błędów',
    duplicateSkuInRows: 'Duplikat SKU "{sku}" znaleziony w wierszach: {rows}',
    quantityExceedsMax: 'Wiersz {row}: Ilość {quantity} przekracza maksymalną dozwoloną ({max})',
    quantityBelowMin: 'Wiersz {row}: Ilość {quantity} jest poniżej wymaganej minimalnej ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nieobsługiwany format pliku. Prześlij plik CSV lub Excel.',
    csvParsingErrors: 'Wystąpiły błędy parsowania CSV',
    failedToParseFile: 'Nie udało się przetworzyć pliku',
    failedToParseExcel: 'Nie udało się przetworzyć pliku Excel',
    failedToReadFile: 'Nie udało się odczytać pliku',
    unknownError: 'Wystąpił nieznany błąd',
    totalRows: 'Wszystkie wiersze',
    valid: 'Prawidłowe',
    invalid: 'Nieprawidłowe',
    skipped: 'Pominięte',
    // SKU validation
    skuValidationError: 'Błąd walidacji SKU',
    skuValidationFailed: 'Nie udało się zwalidować SKU. Możesz kontynuować, ale niektóre pozycje mogą być niedostępne.',
    skuNotFound: 'SKU nie znaleziony w bazie danych',
    skusNotFound: '{count} SKU nie znaleziono w bazie danych',
    itemsHaveInsufficientStock: '{count} produktów ma niewystarczający stan magazynowy',
    validatingSKUs: 'Sprawdzanie produktów...',
    unvalidatedChanges: 'Masz niezwalidowane zmiany. Proszę ponownie zwalidować przed dodaniem do koszyka.',
    revalidate: 'Ponowna walidacja',
    validating: 'Walidacja...',
    validationSuccess: 'Wszystkie produkty są prawidłowe',
    validationComplete: 'Walidacja zakończona',
    validationResultSummary: '{errors} błędów, {warnings} ostrzeżeń znalezionych',
    // Table headers
    actions: 'Akcje',
    notes: 'Uwagi',
    // Status filter
    all: 'Wszystkie',
    hasErrors: 'Ma błędy',
    // Selection summary
    selected: 'wybrane',
    errors: 'błędy',
    // Pagination
    page: 'Strona {current} z {total}',
    previous: 'Poprzednia',
    next: 'Następna',
    noResults: 'Brak wyników.',
    // Cart integration
    noValidItems: 'Brak prawidłowych pozycji',
    allItemsHaveErrors: 'Wszystkie pozycje mają błędy walidacji. Popraw je przed kontynuowaniem.',
    dataLoadingError: 'Błąd ładowania danych',
    failedToLoadProductData: 'Nie udało się załadować danych produktu. Spróbuj ponownie.',
    itemsAddedToCart: '{count} pozycji dodanych do koszyka',
    itemsAddedMessage: 'Dodano {count} pozycji do koszyka',
    someSkusNotFound: '{count} SKU nie mogło być znalezione.',
    noItemsAdded: 'Nie dodano pozycji',
    couldNotFindProducts: 'Nie można znaleźć produktów pasujących do SKU.',
    errorAddingToCart: 'Błąd',
    failedToAddToCart: 'Nie udało się dodać pozycji do koszyka. Spróbuj ponownie.',
    addingToCart: 'Dodawanie do koszyka...',
    // File info
    fileSelected: '{name} wybrany do przetworzenia',
    fileSize: '{size} bajtów',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Pobieranie szablonu',
    templateWillBeImplemented: 'Pobieranie szablonu zostanie zaimplementowane w fazie 7',
    // Additional validation
    validationFailed: 'Walidacja nie powiodła się',
    // Template download
    templateDownloaded: 'Szablon został pomyślnie pobrany',
    templateDownloadError: 'Błąd podczas pobierania szablonu',
    downloadExcelTemplate: 'Pobierz szablon Excel',
    downloadCsvTemplate: 'Pobierz szablon CSV',
    // Template content
    sheetName: 'Zamówienie zbiorcze',
    instructionsSheetName: 'Instrukcje',
    columnDescriptions: 'Opisy kolumn:',
    columnHeader: 'Kolumna',
    columnRequired: 'Wymagane',
    columnOptional: 'Opcjonalne',
    columnDescription: 'Opis',
    templateNotes: 'Uwagi:',
    templateNote1: 'Pierwszy wiersz musi zawierać nagłówki kolumn dokładnie jak pokazano',
    templateNote2: 'Dane zaczynają się od wiersza 2',
    templateNote3: 'SKU musi odpowiadać istniejącym kodom produktów w systemie',
    templateNote4: 'Ilość musi być dodatnią liczbą całkowitą między 1 a 9999',
    templateNote5: 'Maksymalnie 1000 wierszy dozwolonych na plik',
    templateNote6: 'Zapisz jako format .xlsx lub .csv',
    stockAvailabilityWarning: 'Rzeczywista dostępność towaru zostanie sprawdzona na następnej stronie kasy.',
    outOfStock: 'Brak w magazynie',
    insufficientStock: 'Niewystarczający stan magazynowy: {available} dostępne, {requested} żądane',
  },
  orderExport: {
    export: 'Eksportuj zamówienie',
    exportOrder: 'Eksportuj dane zamówienia',
    exportAsCSV: 'Eksportuj jako CSV',
    exportAsExcel: 'Eksportuj jako Excel',
    exportForReorder: 'Eksportuj do importu masowego',
    detailed: 'Pełne szczegóły',
    simpleFormat: 'Format importu',
  },
};